"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWebpackManifest = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../errors/RegistryError");
var libraryManifestBuilder_1 = require("./builders/libraryManifestBuilder");
function parseWebpackManifest(library, libraryAssetsPatterns) {
    if (libraryAssetsPatterns === void 0) { libraryAssetsPatterns = []; }
    var libraryBuilder = libraryManifestBuilder_1.createLibraryManifestBuilder({
        topology: library.topology,
    });
    var _a = library.manifest, webpackRuntimeBundleURL = _a["webpack-runtime.js"], hotBundleURL = _a["hot.js"], components = __rest(_a, ['webpack-runtime.js', 'hot.js']);
    if (webpackRuntimeBundleURL) {
        libraryBuilder.addWebpackRuntimeBundle(webpackRuntimeBundleURL);
    }
    if (hotBundleURL) {
        libraryBuilder.addHotBundle(hotBundleURL);
    }
    Object.keys(components).forEach(function (key) {
        var symbols = editor_elements_conventions_1.parseBundleName(key);
        if (symbols === null) {
            return;
        }
        var host = symbols.host, componentName = symbols.componentName, part = symbols.part, id = symbols.id, batch = symbols.batch, extension = symbols.extension;
        /**
         * If bundle format does not match convention rules.
         * `host` should always be always decoded from the bundle name
         */
        if (!host || batch) {
            return;
        }
        var hostBuilder = libraryBuilder.getHostBuilder(host);
        var url = components[key];
        if (extension === 'js') {
            if (!componentName && !part) {
                hostBuilder.addUrl(id, url);
            }
            else if (componentName) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                if (part) {
                    componentBuilder.addPart(id, part, url);
                }
                else {
                    componentBuilder.addUrl(id, url);
                }
            }
            else if (part) {
                hostBuilder.addSharedChunkModel(part, id, url);
            }
            else {
                throw RegistryError_1.createInternalException();
            }
        }
        else if (extension === 'css') {
            if (!componentName && !part) {
                hostBuilder.addStyleAsset(url);
            }
            else if (componentName) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                componentBuilder.addStyleAsset(url, part);
            }
            else if (part) {
                hostBuilder.addSharedChunkStyleAsset(part, url);
            }
            else {
                throw RegistryError_1.createInternalException();
            }
        }
    });
    libraryAssetsPatterns.forEach(function (_a) {
        var type = _a.type, pattern = _a.pattern;
        Object.keys(library.manifest).forEach(function (id) {
            var url = library.manifest[id];
            if (pattern.test(id)) {
                var extension = url.split('.').pop();
                libraryBuilder.addLibraryAsset(url, type, extension);
            }
        });
    });
    return libraryBuilder.build();
}
exports.parseWebpackManifest = parseWebpackManifest;
//# sourceMappingURL=parseWebpackManifest.js.map